import { navigate } from "gatsby"
import {
  LocalStorageItems,
  SessionStorageItems,
} from "@modules/localStorage/constants"

export {
  isAuthenticated,
  processLoginAttempt,
  authenticatePreview,
} from "./utils"
export { default as useCurrentUser } from "./hooks/useCurrentUser"

export function ssoLogout(path) {
  clearLocalStorage()
  navigate(`/dashboard/sso${path || ``}`)
}

export function logout(path) {
  clearLocalStorage()
  if (path && path.includes("deploynow")) {
    // for the /deploynow flow, redirect users to signup
    // instead of login
    return navigate(`https://app.netlify.com/signup${path || ``}`)
  }
  navigate(`/dashboard/login${path || ``}`)
}

function clearLocalStorage() {
  localStorage.setItem(LocalStorageItems.GatsbyToken, ``)
  localStorage.setItem(LocalStorageItems.GatsbyUserId, ``)
  localStorage.setItem(LocalStorageItems.GatsbyTokenExpiration, ``)
  localStorage.setItem(LocalStorageItems.GatsbyProviderConfigId, ``)
  localStorage.setItem(LocalStorageItems.GatsbySsoToken, ``)
  localStorage.setItem(LocalStorageItems.GatsbySsoTokenExpiration, ``)
  localStorage.setItem(LocalStorageItems.GatsbySentryToken, ``)
  sessionStorage.removeItem(SessionStorageItems.NewSpaceForm)
}
